import PropTypes from 'prop-types';
import { useEffect, useState, useContext} from 'react';

import { DonneesUtilisateurContext } from '../contexte.js';

import { apiPutBlocsToFormation } from '../Datas/dataFormationsBloc.js'

import LoadingSpinner from "../Components/LoadingSpinner";
import MessageInfoBox, { MessageErreurApi } from '../Components/Messages.jsx';
import ButtonDeBase from '../Components/ButtonsCustom.jsx';
import { appelRecupInfoGet } from '../fonctionsDiv.js'

/**
 * Affichage et gestion des blocs d'une certif pour une ID_ACTIONS_FORMATION_BLOCS donnée
 * rappel type validaitond es bloc :  partielle  :0,  mixte  :2
 * 
 * @component
 * @summary importé dans les composants d'édition des formations
 * @param {boolean} props.dataLoaded
 * @return { HTMLElement }
*/
function BlocsCompetencesForm(props) {
    const { utilisateurBearer } = useContext(DonneesUtilisateurContext);
    
    const [dataLoaded, setDataLoaded] = useState(true);
    const [messageProbleme, setMessageProbleme] = useState();
    const [aumoinsUneModif, setAumoinsUneModif] = useState(false);

    const [dataListBlocs, SetDataListBlocs] = useState();

    const handleClickEnvoiInfos = async () => { 
       var cpt = 0;
       var nbBlocTotal = checkedState.length;
       var tabBlocCoches = [];

        checkedState.forEach((el) => {
            if(el == true) { // tableau d'objet qui va etre envoyé, les indice de checkedState correspondent à dataListBlocs c'est pour cela qu'on peut faire ainsi
                var ID_ACTIONS_FORMATION_BLOCS = props.ID_ACTIONS_FORMATION_BLOCS;
                var CODE_BLOC = dataListBlocs[cpt].CODE;
                var LIB_BLOC = dataListBlocs[cpt].LIBELLE;
                tabBlocCoches.push({ ID_ACTIONS_FORMATION_BLOCS, CODE_BLOC, LIB_BLOC }); 
            }
            cpt++;
        });

       var nbBlocCoches = tabBlocCoches.length;

       // si tout les blocs sont cochés, ce n'est pas possible
       if(nbBlocCoches == nbBlocTotal) {
            alert("Vous ne pouvez pas sélectionner tous les blocs.\r\nVeuillez désélectionner au moins un bloc de compétence.");
            return false;
       }
       // s aucun bloc n'est coché, ce n'est pas possible
       if(nbBlocCoches == 0) {
            alert("Vous devez sélectionner au moins un bloc de compétence.");
            return false;
       }

       setAumoinsUneModif(false);
       setDataLoaded(false);

       var dataR = await apiPutBlocsToFormation(utilisateurBearer, props.ID_ACTIONS_FORMATION_BLOCS, tabBlocCoches); // model apiProfPutProfFormacode
       if(global.config.modeDebugApp == 1) console.log('retour apiPutBlocsToFormation : ', dataR);
       
       switch (dataR.statusCode) {
           case 200:
               setDataLoaded(true);
               props.setnbBlocEnregistres(nbBlocCoches);
               alert("Les modifications ont bien été enregistrées.");

             break;
           case 401:
               setMessageProbleme(global.config.msgPrTechnique.msgUnauthorized); // Problème technique Unauthorized
             break;
           case 400:
               setMessageProbleme(dataR.dataApi); // un message personnalisé est retourné
             break;
           default:
               setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
       }
       
    }


    async function chargementsConsecutifs() {
        setDataLoaded(false);
        var pb = false;
        var retListBlocs = await appelRecupInfoGet(utilisateurBearer, "certifs/blocs-competences/Search?code-rncp=" + props.code_rncp + 
                                                                        "&ID_ACTIONS_FORMATION_BLOCS=" + props.ID_ACTIONS_FORMATION_BLOCS, setMessageProbleme);
        if(retListBlocs != null) {
            SetDataListBlocs(retListBlocs); 
            // on initialise un tableau pour la gestion des checkbox, l'idée est d'avoir juste le meme nombre d'indice 
            var tab=[];
            var cpt=0;
            retListBlocs.forEach((el) => {
                tab[cpt] = el.CODE_BLOC_ASSOCIE != null ? true : false;
                cpt++;
            });
            setCheckedState(tab);
        } else pb = true;

        if(pb == true ) setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
      //}
      setDataLoaded(true);
    }

    useEffect(() => {
        setMessageProbleme(null);
        chargementsConsecutifs();
    }, []);


    // gestion de la selection des blocs
    // inspi https://codesandbox.io/s/wild-silence-b8k2j?file=/src/App.js:940-947 de https://www.freecodecamp.org/news/how-to-work-with-multiple-checkboxes-in-react/
    const [checkedState, setCheckedState] = useState();
    const handleChangeCheckBoxBloc = (position) => {
        setAumoinsUneModif(true);
        props.setnbBlocEnregistres(0);
        console.log("setnbBlocEnregistres à 0 car modif en cours");
        const updatedCheckedState = checkedState.map((item, index) =>
          index === position ? !item : item
        );
        setCheckedState(updatedCheckedState);
    };


  return (
    <>
        {
        <div style={{paddingTop: "20px"}}>
                <LoadingSpinner dataLoaded={dataLoaded}/>
                <MessageErreurApi message={messageProbleme} />
                {global.config.modeDebugApp == 111111111 && <div className='debug'>Edition de l'ID_ACTIONS_FORMATION_BLOCS <b>{props.ID_ACTIONS_FORMATION_BLOCS}</b></div>}
                {dataListBlocs && dataListBlocs.length > 0  &&

                        <>
                            <br />
                            {props.infosGenFormation["nbActions"] == 0 ?
                            <>
                                <MessageInfoBox message="Cette certification comporte les blocs suivants, choisissez celui ou celles que cette formation prépare :" />
                                <ul className="list-bloc">
                                {dataListBlocs && dataListBlocs.map((item, index) => {
                                        return (
                                            <li key={item.CODE}>
                                                <input type="checkbox"
                                                    id={`custom-checkbox-${index}`}
                                                    checked={checkedState[index]}
                                                    onChange={() => handleChangeCheckBoxBloc(index)}
                                                />&nbsp;&nbsp;&nbsp;
                                                <label htmlFor={`custom-checkbox-${index}`}>{item.CODE}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {item.LIBELLE}</label>
                                            </li>
                                        );
                                        })
                                }
                                </ul>
                            </>
                            :
                            <>
                                <MessageInfoBox message="Les blocs suivants sont préparés par cette certification :" />
                                <ul className="list-bloc">
                                {dataListBlocs && dataListBlocs.map((item, index) => {
                                        return (
                                            <li key={item.CODE}>
                                                {checkedState[index] ? <>✔️ </> : <>⛔ </>}
                                                <label htmlFor={`custom-checkbox-${index}`}>{item.CODE}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {item.LIBELLE}</label>
                                            </li>
                                        );
                                        })
                                }
                                </ul>
                            </>}
                        </>
                }

                {props.infosGenFormation["nbActions"] == 0 &&
                    <ButtonDeBase typeSubmit={false} lib="Mettre à jour 👍" disabled={aumoinsUneModif == true ? false : true}  onClick={() =>handleClickEnvoiInfos()} />}
        </div>
    }
    </>
  );
}


BlocsCompetencesForm.propTypes = {
    ID_ACTIONS_FORMATION_BLOCS: PropTypes.number.isRequired,
    code_rncp: PropTypes.number.isRequired,
    setnbBlocEnregistres: PropTypes.func.isRequired,
    infosGenFormation: PropTypes.object.isRequired,
}

export default BlocsCompetencesForm;